export default __webpack_public_path__ + "media/titles/title_1_locale_en-79898756.png";